module.exports = __webpack_public_path__ + "3.1.3-imagery-product.html";